import { JsonApiPayload, ModelLike } from 'services/interfaces/JsonApiPayload';

export class BrandingSettingsPayload extends JsonApiPayload {
  id: string
  logoUrl: string
  logoDataUri: string
  faviconUrl: string
  faviconDataUri: string
  primaryColor: string
  secondaryColor: string
  tertiaryColor: string
  font1Id: string
  font2Id: string
  font3Id: string

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    return super._getSchema(this, []);
  }
}
